import { render, staticRenderFns } from "./customerPhoneList.vue?vue&type=template&id=6249e843&scoped=true"
import script from "./customerPhoneList.vue?vue&type=script&lang=js"
export * from "./customerPhoneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249e843",
  null
  
)

export default component.exports